export const AppConfig = {
	APP_ID: "elglobodistrict",
	API_BASE_URL: "https://elglobodistrict.com/platform",
	APP_NOT_VALUE: "--",
}
